import { useEffect, useState } from 'react';
import { fetchLeads } from '@/services/api/lead';
import { processAPIResponseNow } from '@/utils/request';
import { contactProjectSearchTerm, projectsOfContact } from '@/utils/contacts';
import { ContactModel } from '@/typings/models/Contact';
import { LeadModel } from '@/typings/models/Lead';

const MAX_PROJECTS = 50;

/**
 * The projects a contact is on. No endpoint returns them, so search the
 * project list (it matches any contact's email or name) and keep the
 * projects whose contacts include this one. `null` while loading.
 */
export const useContactProjects = (contact?: ContactModel | null): LeadModel[] | null => {
  const [projects, setProjects] = useState<LeadModel[] | null>(null);
  const contactId = contact?.id;
  const term = contactProjectSearchTerm(contact);

  useEffect(() => {
    if (!contactId) return undefined;
    if (!term) {
      setProjects([]);
      return undefined;
    }
    let active = true;
    setProjects(null);
    fetchLeads({ query: { search: term, page_size: MAX_PROJECTS } }).then((response) =>
      processAPIResponseNow(response, {
        onSuccess: (body: any) => {
          const leads: LeadModel[] = Array.isArray(body?.data) ? body.data : Array.isArray(body) ? body : [];
          if (active) setProjects(projectsOfContact(contactId, leads));
        },
        onError: () => active && setProjects([]),
      }),
    );
    return () => {
      active = false;
    };
  }, [contactId, term]);

  return projects;
};
